import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Card, Typography, Modal, Table, message, Tag, List, Input, Button, Space, Form, Select, Drawer } from 'antd';
import { BookOutlined, UserOutlined, SendOutlined, LockOutlined, TeamOutlined, EditOutlined } from '@ant-design/icons';
import withRoleAccess from '../../hoc/withRoleAccess';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faClock, faCalendarAlt, faCloudUpload, faUpload, faCheck, faTimes, faMinus, faEdit,
 faChalkboardTeacher, faBook, faVideo, faUserClock, faSave, 
  faLock, faTrash, faUser, faCalendar, faFileAlt, faFilePdf, faDoorOpen, 
  faLocation} from '@fortawesome/free-solid-svg-icons';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './Classes.css';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import LessonPlanModal from './LessonPlanModal';

const { Title, Text } = Typography;
const { TextArea } = Input;
const ClassDetails = () => {
  const { t, i18n } = useTranslation();
  const { groupid } = useParams();
    const [currentUser, setCurrentUser] = useState(null);
  const [classDetails, setClassDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attendance, setAttendance] = useState({});
  const [attendanceStatistics, setAttendanceStatistics] = useState({});
  const [savedAttendances, setSavedAttendances] = useState({});
  const [savingInProgress, setSavingInProgress] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [classComments, setClassComments] = useState({});
  const [registeredStudents, setRegisteredStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [submittedSchedules, setSubmittedSchedules] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [newVideoMeetingLinks, setNewVideoMeetingLinks] = useState({});
  const [isCommentSaved, setIsCommentSaved] = useState({});
  const [videoMeetingLinks, setVideoMeetingLinks] = useState({});
  const [selectedPdfs, setSelectedPdfs] = useState({});
  const [isSubmittedHomeworkOpen, setIsSubmittedHomeworkOpen] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [studentUploadedPdfs, setStudentUploadedPdfs] = useState({});
  const [uploadedPdfs, setUploadedPdfs] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [homework, setHomework] = useState({});
  const [editMode, setEditMode] = useState({});
  const [attendanceData, setAttendanceData] = useState([]);
  const [lessonPlanVisible, setLessonPlanVisible] = useState(false);
  const [currentLessonPlan, setCurrentLessonPlan] = useState(null);
  const [lessonPlanLoading, setLessonPlanLoading] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [studentsInClass, setStudentsInClass] = useState([]); 
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [selectedClassFeedback, setSelectedClassFeedback] = useState(null);
  const [isFeedbackApproved, setIsFeedbackApproved] = useState(false);
  const [feedbackData, setFeedbackData] = useState({
    warmup: '',
    task_1: '',
    task_2: '',
    task_3: '',
    homework: '',
    reflection: '',
    comment: ''
  });
  const API_URL = process.env.REACT_APP_API_URL;


  const formatDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
      return '-'; // Fallback if it's null or invalid
    }
  
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: '2-digit' };
    return new Intl.DateTimeFormat(i18n.language, options).format(date).toUpperCase();
  };
  

  const formatUploadDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // This forces 24-hour format
    };
    return new Intl.DateTimeFormat(i18n.language, options).format(date);
  };
  const formatTime = (timeString) => {
    if (!timeString) return '-';
    const [hour, minute] = timeString.split(':');
    if (!hour || !minute) return '-';
    return `${hour}:${minute}`;
  };
  
  
  const formatMinutesToHours = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}:${remainingMinutes.toString().padStart(2, '0')} ${t('hr')}`;
  };
  
  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };


  const calculateEndTime = (startTime, durationMinutes) => {
    return moment(startTime, 'HH:mm:ss')
      .add(durationMinutes, 'minutes')
      .format('HH:mm');
  };

  const calculateClassEndTime = (startTime, durationMinutes) => {
    const timeParts = startTime.split(':');
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
  
    const momentTime = moment().hours(hours).minutes(minutes);

    const endTime = momentTime.add(durationMinutes, 'minutes');

    return endTime.format('HH:mm');
  };
  

  useEffect(() => {
    const fetchCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const user = response.data;
    setCurrentUser(user); // Save to state or context
  } catch (error) {
    console.error('Error fetching current user:', error);
  }
};

    const fetchClassDetails = async () => {
      try {
        const response = await axios.get(`${API_URL}/class-groups/${groupid}`);
        setClassDetails(response.data);

        const { classgroup_ids, classes } = response.data;

        const fetchMessages = async () => {
          const token = localStorage.getItem('token');
          const messageResponses = await Promise.all(classgroup_ids.map(id => 
            axios.get(`${API_URL}/messages/${id}`, {
              headers: { Authorization: `Bearer ${token}` },
            }) 
          ));
          const messages = messageResponses.flatMap(res => res.data);
          setMessages(messages);
        };

        const fetchAttendanceStatus = async () => {
          const token = localStorage.getItem('token');
          const attendanceResponses = await Promise.all(classes.map(cls => 
            axios.get(`${API_URL}/attendance/${cls.classid}`, {
              headers: { Authorization: `Bearer ${token}` },
            })
          ));
          const submittedClassIds = attendanceResponses
            .filter(res => res.data.length > 0)
            .map(res => res.config.url.split('/').pop());
          setSubmittedSchedules(submittedClassIds);
        };

        const fetchAttendanceStatistics = async () => {
          try {
            const token = localStorage.getItem('token');
            if (!groupid) {
              console.warn('[fetchAttendanceStatistics] groupid is missing:', groupid);
              return;
            }
            const response = await axios.get(`${API_URL}/attendance/group/${groupid}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            setAttendanceStatistics(response.data);
          } catch (error) {
            console.error('[fetchAttendanceStatistics] Error fetching attendance stats:', error);
          }
        };

        const fetchAllClassComments = async () => {
          const token = localStorage.getItem('token');
          const commentResponses = await Promise.all(classes.map(cls => 
            axios.get(`${API_URL}/class-comments/${cls.classid}`, {
              headers: { Authorization: `Bearer ${token}` },
            })
          ));
          const commentsData = commentResponses.flatMap(res => res.data);
          const formattedComments = commentsData.reduce((acc, comment) => {
            acc[comment.classid] = comment.comment;
            return acc;
          }, {});
          setClassComments(formattedComments);
          setIsCommentSaved(Object.keys(formattedComments).reduce((acc, classid) => {
            acc[classid] = true;
            return acc;
          }, {}));
        };

        const fetchAllVideoMeetingLinks = async () => {
          const token = localStorage.getItem('token');
          const videoLinkResponses = await Promise.all(classes.map(cls =>
            axios.get(`${API_URL}/video-meeting-links/${cls.classid}`, {
              headers: { Authorization: `Bearer ${token}` },
            })
          ));
          const videoLinksData = videoLinkResponses.flatMap(res => res.data);
          const formattedVideoLinks = videoLinksData.reduce((acc, link) => {
            acc[link.classid] = link.video_meeting_link;
            return acc;
          }, {});
          setVideoMeetingLinks(formattedVideoLinks);
        };

        const fetchClassPdfs = async () => {
          try {
              const token = localStorage.getItem('token');
              const pdfResponses = await Promise.all(classes.map(cls =>
                  axios.get(`${API_URL}/upload/class/${cls.classid}`, {
                      headers: { Authorization: `Bearer ${token}` }
                  })
              ));
              const pdfData = pdfResponses.flatMap(res => res.data);
              const formattedPdfs = pdfData.reduce((acc, pdf) => {
                  if (!acc[pdf.classid]) {
                      acc[pdf.classid] = [];
                  }
                  acc[pdf.classid].push(pdf);
                  return acc;
              }, {});
              setUploadedPdfs(formattedPdfs);
          } catch (error) {
              console.error('Error fetching PDFs for classes:', error);
          }
      };

      const fetchStudentPdfs = async () => {
        try {
            const token = localStorage.getItem('token');
            // Fetch PDFs for each class
            const pdfResponses = await Promise.all(classes.map(cls =>
                axios.get(`${API_URL}/upload/studentupload/class/${cls.classid}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ));
    
            // Flatten the responses and log the data
            const pdfData = pdfResponses.flatMap(res => res.data);
    
            // Reduce the data into the correct format for each class
            const formattedPdfs = pdfData.reduce((acc, pdf) => {
                if (!acc[pdf.class_id]) {
                    acc[pdf.class_id] = [];
                }
                acc[pdf.class_id].push(pdf);
                return acc;
            }, {});
  
    
            setStudentUploadedPdfs(formattedPdfs); // Set state
        } catch (error) {
            console.error('Error fetching PDFs for classes:', error);
        }
    };
    
        
        fetchCurrentUser();
        fetchMessages();
        fetchAttendanceStatus();
        fetchAttendanceStatistics();
        fetchAllClassComments();
        fetchAllVideoMeetingLinks();
        fetchClassPdfs();
        fetchStudentPdfs();

      } catch (error) {
        setError('Failed to fetch class details.');
      } finally {
        setLoading(false);
      }
    };

    const fetchRegisteredStudents = async () => {
      try {
        const response = await axios.get(`${API_URL}/registrations/classgroup/${groupid}`);
        setRegisteredStudents(response.data);
      } catch (error) {
        console.error('Error fetching registered students:', error);
      }
    };

    fetchClassDetails();
    fetchRegisteredStudents();
  }, [groupid, API_URL]);

  const handleSendMessage = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API_URL}/messages`,
        { groupid, message: newMessage },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNewMessage('');
      setMessages(prevMessages => [
        ...prevMessages,
        { nickname: 'You', lastname: '', message: newMessage, timestamp: new Date().toISOString() }
      ]);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };
  const handleViewLessonPlan = async (classId) => {
    try {  
      setLessonPlanLoading(true);
      const token = localStorage.getItem('token');
      const endpoint = `${API_URL}/lessonplan/by-class/${classId}`;  
      const response = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setCurrentLessonPlan(response.data);
      setLessonPlanVisible(true);
    } catch (error) {
      console.error('[ViewLessonPlan] Error fetching lesson plan:', error);
  
      if (error.response?.status === 404) {
        console.info('[ViewLessonPlan] No lesson plan found for classId:', classId);
        message.info(t('noLessonPlanFound'));
      } else {
        message.error(t('errorFetchingLessonPlan'));
      }
    } finally {
      setLessonPlanLoading(false);
    }
  };
  

  const handleClassCommentChange = (classId, value) => {
    setClassComments((prev) => ({
      ...prev,
      [classId]: value,
    }));
    setNewComment(value); // Update the newComment state as well
  };


  const handleAddVideoMeetingLink = async (classid) => {
    try {
      const token = localStorage.getItem('token');
      const linkValue = newVideoMeetingLinks[classid];  // Get the specific link for this class
  
      if (!linkValue) return;  // Don't proceed if no link is provided
  
      await axios.post(
        `${API_URL}/video-meeting-links`,
        { classid, video_meeting_link: linkValue },  // Use the specific link
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      setVideoMeetingLinks((prev) => ({
        ...prev,
        [classid]: linkValue,  // Use the specific link
      }));
  
      // Clear only this specific class's input
      setNewVideoMeetingLinks(prev => {
        const updated = { ...prev };
        delete updated[classid];
        return updated;
      });
  
    } catch (error) {
      console.error('Error adding video meeting link:', error);
    }
  };
  const handleDeleteVideoMeetingLink = async (classid) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/video-meeting-links/${classid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVideoMeetingLinks((prev) => ({
        ...prev,
        [classid]: null,
      }));
    } catch (error) {
      console.error('Error deleting video meeting link:', error);
    }
  };

const handleOpenFeedback = async (slot) => {
  try {
    setSelectedClassFeedback(slot);
    setFeedbackVisible(true);

    const token = localStorage.getItem('token');
    const groupid = slot.groupid || slot.class_group_id || slot.classid;

    const studentsResponse = await axios.get(`${API_URL}/registrations/classgroup/${groupid}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setStudentsInClass(studentsResponse.data);
    setFeedbackData({ // Clear previous data
      warmup: '',
      task_1: '',
      task_2: '',
      task_3: '',
      homework: '',
      reflection: '',
      comment: ''
    });
    setIsFeedbackApproved(false);
    setStudentId(null); // Reset student

  } catch (err) {
    console.error('❌ Failed to fetch feedback or students:', err);
    message.error('Failed to load data for this class');
  }
};


const handleCloseFeedback = () => {
  setFeedbackVisible(false);
  setSelectedClassFeedback(null);
  setStudentId(null);
  setFeedbackData({
    warmup: '',
    task_1: '',
    task_2: '',
    task_3: '',
    homework: '',
    reflection: '',
    comment: ''
  });
};

const handleSubmitFeedback = async () => {
  if (!studentId || !selectedClassFeedback) {
    message.warning('Please select a student and a class.');
    return;
  }

  if (isFeedbackApproved) {
    message.warning('Cannot update. Feedback is already approved.');
    return;
  }

  const token = localStorage.getItem('token');

  const payload = {
    classid: selectedClassFeedback.classid,
    teacher_id: selectedClassFeedback.teacher_id,
    student_id: studentId,
    ...feedbackData,
  };

  try {
    // Check if feedback already exists
    const checkRes = await axios.get(
      `${API_URL}/student-feedback/check/${payload.classid}/${payload.teacher_id}/${payload.student_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (checkRes.data.exists) {
      // If exists, do PUT
      await axios.put(`${API_URL}/student-feedback/${checkRes.data.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success('Feedback updated successfully');
    } else {
      // If not, do POST
      await axios.post(`${API_URL}/student-feedback`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success('Feedback submitted successfully');
    }

    handleCloseFeedback();
  } catch (error) {
    console.error('Error submitting feedback:', error);
    message.error('Failed to submit feedback');
  }
};



useEffect(() => {
  if (!attendanceStatistics?.attendance) return;

  const { present, absent, late15, lateOver15 } = attendanceStatistics.attendance;

  const data = [
    { name: t('present'), value: present, color: '#52c41a' },
    { name: t('absent'), value: absent, color: '#ff4d4f' },
    { name: t('late ≤ 15 M'), value: late15, color: '#faad14' },
    { name: t('late > 15 M'), value: lateOver15, color: '#d46b08' }
  ];

  setAttendanceData(data);
}, [attendanceStatistics, t]);


  const handleNewVideoMeetingLink = (classId, value) => {
    setNewVideoMeetingLinks(prev => ({
      ...prev,
      [classId]: value
    }));
  };

  const handlePdfChange = (e, classId) => {
    const selectedFile = e.target.files[0];
    setSelectedPdfs(prev => ({
        ...prev,
        [classId]: selectedFile
    }));
};
const handlePdfUpload = async (classId) => {
  if (!selectedPdfs[classId]) {
    console.error('No PDF selected');
    return;
  }

  const formData = new FormData();
  formData.append('pdfFile', selectedPdfs[classId]);
  formData.append('classid', classId);

  const userId = localStorage.getItem('userId');
  formData.append('userId', userId);

  try {
    const token = localStorage.getItem('token');
    await axios.post(`${API_URL}/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    // ✅ Refetch all PDFs for this class
    const pdfResponse = await axios.get(`${API_URL}/upload/class/${classId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setUploadedPdfs((prev) => ({
      ...prev,
      [classId]: pdfResponse.data, // refresh with latest list
    }));

    // Clear only this class's selected PDF
    setSelectedPdfs((prev) => {
      const updated = { ...prev };
      delete updated[classId];
      return updated;
    });

    confirmAlert({
      title: 'Success',
      message: 'PDF uploaded successfully!',
      buttons: [{ label: 'OK', onClick: () => {} }],
    });
  } catch (error) {
    console.error('Error uploading PDF:', error);
    confirmAlert({
      title: 'Error',
      message: 'Failed to upload PDF. Please try again.',
      buttons: [{ label: 'OK', onClick: () => {} }],
    });
  }
};
const handleDeletePdf = (fileId, classId) => {
  confirmAlert({
    title: 'Confirm Deletion',
    message: 'Are you sure you want to delete this PDF?',
    buttons: [
      {
        label: 'Yes',
        onClick: async () => {
          try {
            const token = localStorage.getItem('token');
            await axios.delete(`${API_URL}/upload/class/${fileId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });

            // Refetch or update state
            setUploadedPdfs(prev => {
              const updated = { ...prev };
              updated[classId] = updated[classId].filter(pdf => pdf.id !== fileId);
              return updated;
            });

            confirmAlert({
              title: 'Deleted',
              message: 'PDF deleted successfully!',
              buttons: [{ label: 'OK', onClick: () => {} }],
            });
          } catch (error) {
            console.error('Error deleting PDF:', error);
            confirmAlert({
              title: 'Error',
              message: 'Failed to delete PDF. Please try again.',
              buttons: [{ label: 'OK', onClick: () => {} }],
            });
          }
        },
      },
      {
        label: 'No',
        onClick: () => {}, // do nothing
      },
    ],
  });
};



const handleOpenSubmissions = (classid) => {
  setSelectedClassId(classid);
  setIsSubmittedHomeworkOpen(true);
};

const handleAttendanceChange = (studentId, field, value) => {
  setAttendance(prev => ({
    ...prev,
    [studentId]: {
      ...prev[studentId],
      [field]: value
    }
  }));
};

const handleHomeworkChange = (studentId, value) => {
  setHomework(prev => ({
    ...prev,
    [studentId]: value
  }));
};

const handleEdit = (studentId) => {
  setEditMode(prev => ({
    ...prev,
    [studentId]: true
  }));
  // Initialize edit form with current values
  setAttendance(prev => ({
    ...prev,
    [studentId]: {
      status: savedAttendances[studentId].status,
      comment: savedAttendances[studentId].comment
    }
  }));
  setHomework(prev => ({
    ...prev,
    [studentId]: savedAttendances[studentId].homework
  }));
};

const handleUpdate = async (studentId) => {
  try {
    const token = localStorage.getItem('token');
    const savedRecord = savedAttendances[studentId];
    
    if (!savedRecord || !savedRecord.attendance_id) {
      console.error('No attendance record found for update');
      alert('Unable to update: Record not found');
      return;
    }

    const response = await axios.put(
      `${API_URL}/attendance/${savedRecord.attendance_id}`,
      {
        status: attendance[studentId].status,
        comment: attendance[studentId].comment || '',
        homework: homework[studentId] || 'N/A'
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    // Make sure we're including all fields from the response
    setSavedAttendances(prev => ({
      ...prev,
      [studentId]: {
        ...response.data  // Use the entire response data which includes edited_at
      }
    }));

    // Clear edit mode
    setEditMode(prev => {
      const newState = { ...prev };
      delete newState[studentId];
      return newState;
    });

    // Refresh the data to ensure we have the latest state
    await handleShowModal(selectedClass);

  } catch (error) {
    console.error('Error updating attendance:', error);
    alert('Failed to update attendance');
  }
};

const handleSaveAttendance = async (studentId) => {
  if (!attendance[studentId]?.status) {
    alert('Please select an attendance status');
    return;
  }

  setSavingInProgress(true);
  try {
    const token = localStorage.getItem('token');
    const attendanceData = [{
      student_id: studentId,
      status: attendance[studentId].status,
      comment: attendance[studentId].comment || '',
      homework: homework[studentId] || 'N/A' // Add homework status
    }];

    await axios.post(
      `${API_URL}/attendance`,
      {
        groupid: classDetails.groupid,
        classid: selectedClass.classid,
        attendance: attendanceData
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    // Update saved attendances with homework
    setSavedAttendances(prev => ({
      ...prev,
      [studentId]: {
        ...attendance[studentId],
        homework: homework[studentId],
        timestamp: new Date().toISOString()
      }
    }));

    // Clear the current student's attendance and homework
    setAttendance(prev => {
      const newState = { ...prev };
      delete newState[studentId];
      return newState;
    });
    setHomework(prev => {
      const newState = { ...prev };
      delete newState[studentId];
      return newState;
    });

  } catch (error) {
    console.error('Error saving attendance:', error);
    alert('Failed to save attendance');
  } finally {
    setSavingInProgress(false);
  }
};

const handleShowModal = async (cls) => {
  setSelectedClass(cls);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/attendance/${cls.classid}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Format existing attendance records
    const existingAttendance = response.data.reduce((acc, record) => {
      acc[record.student_id] = {
        attendance_id: record.attendance_id,
        status: record.status,
        comment: record.comment,
        homework: record.homework,
        timestamp: record.timestamp,
        edited_at: record.edited_at // Make sure this is being set
      };
      return acc;
    }, {});

    setSavedAttendances(existingAttendance);
    setAttendance({});
    setHomework({});
  } catch (error) {
    console.error('Error fetching attendance:', error);
  }
};

const downloadCSV = () => {
  // Only proceed if there's data
  if (!studentUploadedPdfs[selectedClassId]?.length) return;

  // Create CSV content
  const csvContent = [
    // Header row
    ['Student Name', 'Uploaded Date', 'File Name', 'Homework Status'],
    // Data rows
    ...studentUploadedPdfs[selectedClassId].map(pdf => [
      pdf.nickname,
      formatUploadDate(pdf.upload_date),
      pdf.originalname,
      pdf.homework_status || 'N/A' // Add homework status
    ])
  ]
  .map(row => row.join(','))
  .join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'submitted_homework.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadAttendanceCSV = () => {
  if (!registeredStudents?.length) return;

  // Create CSV content
  const csvContent = [
    // Header row
    ['Student Name', 'Status', 'Homework', 'Comments', 'Time', 'Last Edited'],  // Added Last Edited column
    // Data rows
    ...registeredStudents.map(student => {
      const record = savedAttendances[student.student_id];
      return [
        `${student.student_name} (${student.nickname})`,
        record ? record.status : '',
        record ? record.homework || 'N/A' : '',
        record ? record.comment : '',
        record ? moment(record.timestamp).format('DD-MMM-YYYY HH:mm') : '',
        record && record.edited_at ? moment(record.edited_at).format('DD-MMM-YYYY HH:mm') : '-'  // Added edited_at
      ];
    })
  ]
  .map(row => {
    // Escape any commas in the data to prevent CSV formatting issues
    return row.map(cell => {
      if (cell && cell.includes(',')) {
        return `"${cell}"`;
      }
      return cell;
    }).join(',');
  })
  .join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `attendance_${selectedClass?.subject_name}_${moment(selectedClass?.date).format('DD-MM-YYYY')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!classDetails) return <p>No class details found.</p>;

  const roleColors = {
    student: 'blue',
    teacher: 'green',
    admin: 'red',
    superadmin: 'gray',
  };

  const getRoleTag = (role) => (
    <Tag
      color={roleColors[role] || roleColors.default}
      style={{
        marginLeft: 8,
        fontSize: '10px',
        padding: '0 4px',
        lineHeight: '16px',
        height: '16px',
        borderRadius: '4px',
      }}
    >
      {role}
    </Tag>
  );
  
// Add this function in your ScheduleModal component
const getPlatformText = (platform) => {
  switch(platform) {
    case 'online':
      return t('online');
    case 'onsite':
      return t('onsite');
    case 'athome':
      return t('athome');
    default:
      return platform || t('notAvailable');
  }
};

  const homeworkStatusStyles = {
    yes: {
      backgroundColor: '#d4edda',
      color: '#155724',
      border: '1px solid #c3e6cb'
    },
    no: {
      backgroundColor: '#f8d7da',
      color: '#721c24',
      border: '1px solid #f5c6cb'
    },
    na: {
      backgroundColor: '#e2e3e5',
      color: '#383d41',
      border: '1px solid #d6d8db'
    }
  };
  const columns = [
    {
      title: t('day'),
      dataIndex: 'date',
      key: 'day',
      render: (date) => moment(date).format('dddd'),
    },
    {
      title: t('date'),
      dataIndex: 'date',
      key: 'date',
      render: (date) => moment(date).format('DD MMMM YYYY'),
    },    
    {
      title: t('time'),
      dataIndex: 'schedule_time',
      key: 'time',
      render: (startTime, record) => {
        const formattedStartTime = moment(startTime, 'HH:mm:ss').format('HH:mm');
        const endTime = calculateEndTime(startTime, record.schedule_hour);
        const formattedEndTime = moment(endTime, 'HH:mm:ss').format('HH:mm');
        return `${formattedStartTime} - ${formattedEndTime}`;
      },
    },    
    {
      title: t('subjectName'),
      dataIndex: 'subject_name',
      key: 'subject_name',
    },
    {
      title: t('teacherName'),
      dataIndex: 'nickname',
      key: 'teacherName',
    },
    {
      title: t('hours'),
      dataIndex: 'schedule_hour',
      key: 'hours',
      render: (schedule_hour) => `${(schedule_hour / 60).toFixed(2)} ${t('hrs')}`,
    },
  ];

  const sortedClasses = classDetails?.classes
    ?.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      if (dateA.getTime() !== dateB.getTime()) {
        return dateA - dateB;
      } else {
        const timeA = a.schedule_time ? a.schedule_time.split(':').map(Number) : [0, 0];
        const timeB = b.schedule_time ? b.schedule_time.split(':').map(Number) : [0, 0];
        return timeA[0] !== timeB[0] ? timeA[0] - timeB[0] : timeA[1] - timeB[1];
      }
    }) || [];

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="class-details-container">
      <Card className="class-header-card">
      <div className="class-header-content">
        <Title level={2} className="class-code">
          {classDetails.class_code}
        </Title>
        
        <div className="info-container">
          <div className="info-section">
            <div className="section-header">
              <BookOutlined className="section-icon" />
              <Text className="section-label">SUBJECTS</Text>
            </div>
            <Text className="section-content">
              {classDetails.subjects && classDetails.subjects.length > 0 
                ? classDetails.subjects.join(', ')
                : 'No subjects'}
            </Text>
          </div>

          <div className="divider" />

          <div className="info-section">
            <div className="section-header">
              <UserOutlined className="section-icon" />
              <Text className="section-label">TEACHERS</Text>
            </div>
            <Text className="section-content">
              {classDetails.teachers && classDetails.teachers.length > 0 
                ? classDetails.teachers.join(', ')
                : 'No teachers'}
            </Text>
          </div>
        </div>
      </div>
    </Card>

        <div className="info-attendance-row">
        <div className="class-info-container">
  <div className="class-info-header">
    <h3>{t('classDetails')}</h3>
  </div>
  <div className="info-list">
    <div className="info-item">
      <div className="info-icon">
        <FontAwesomeIcon icon={faCalendar} />
      </div>
      <div className="info-content">
        <div className="info-label">{t('startDate')}</div>
        <div className="info-value">{formatDate(classDetails.start_date)}</div>
      </div>
    </div>

    <div className="info-item">
      <div className="info-icon">
        <FontAwesomeIcon icon={faClock} />
      </div>
      <div className="info-content">
        <div className="info-label">{t('totalHours')}</div>
        <div className="info-value">{formatMinutesToHours(classDetails.total_hours)}</div>
      </div>
    </div>

    <div className="info-item">
      <div className="info-icon">
        <FontAwesomeIcon icon={faBook} />
      </div>
      <div className="info-content">
        <div className="info-label">{t('Notes')}</div>
        <div className="info-value">{classDetails.book_details_materials}</div>
      </div>
    </div>
  <div className="info-item">
  <div className="info-icon">
    <FontAwesomeIcon icon={faLocation} />
  </div>
  <div className="info-content">
    <div className="info-label">{t('platform')}</div>
    <div className="info-value">{getPlatformText(classDetails.platform)}</div>
  </div>
</div>

    <div className="info-item">
      <div className="info-icon">
        <FontAwesomeIcon icon={faUser} />
      </div>
      <div className="info-content">
        <div className="info-label">{t('type')}</div>
        <div className="info-value">{classDetails.isprivate ? t('private') : t('group')}</div>
      </div>
    </div>
  </div>

  <button className="schedule-button" onClick={() => setIsModalOpen(true)}>
    <FontAwesomeIcon icon={faCalendarAlt} />
    {t('scheduleDetails')}
  </button>
</div>

<div className="attendance-container">
            <h3>{t('classPerformance')}</h3>
            <div className="attendance-stats">
              <p>{t('present')}: {attendanceStatistics.attendance?.presentPercentage || '0.00'}%</p>
              <p>{t('absent')}: {attendanceStatistics.attendance?.absentPercentage || '0.00'}%</p>
              <p>{t('late')}: {attendanceStatistics.attendance?.latePercentage || '0.00'}%</p>
            </div>
            <div className="attendance-chart" style={{ width: '100%', height: 300 }}>
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie
                        data={attendanceData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        innerRadius={80}
                        fill="#8884d8"
                        paddingAngle={5}
                      >
                        {attendanceData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
          </div>
        </div>

        <div className="info-attendance-row">        
          <div className="registered-students-container">
            <div className="registered-students-header">
              <h3>{t('registeredStudents')}</h3>
              <div className="student-count">
                <FontAwesomeIcon icon={faUsers} />
                <span>{registeredStudents.length} {t('students')}</span>
              </div>
            </div>
            <div className="students-list">
              {registeredStudents.map((student) => (
                <div key={student.student_id} className="student-item">
                  <div className="student-info">
                    <div className="student-name">
                      {student.student_name}
                      {student.nickname && (
                        <span className="student-nickname"> ({student.nickname})</span>
                      )}
                    </div>

                    <div className="student-tags">
                      {student.age && (
                        <Tag color="green">{t('age')}: {student.age}</Tag>
                      )}
                      {student.currenteducationlevel && (
                        <Tag color="blue">{student.currenteducationlevel}</Tag>
                      )}
                      {student.schoolname && (
                        <Tag color="purple">{student.schoolname}</Tag>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Card title={t('messages')} bordered className="class-messages-container">
    <List
      dataSource={messages}
      className="message-list"
      renderItem={(msg) => (
        <List.Item className="message-item">
          <List.Item.Meta
            title={
              <div className="message-sender">
                <strong>{msg.nickname}</strong>
                {getRoleTag(msg.role)}
              </div>
            }
            description={
              <>
                <div className="message-content">{msg.message}</div>
                <Text type="secondary" className="message-time">
                  {formatDate(msg.timestamp)} {t('at')} {formatDateTime(msg.timestamp)}
                </Text>
              </>
            }
          />
        </List.Item>
      )}
    />

    <div className="message-input-container" style={{ marginTop: 16 }}>
      <TextArea
        rows={3}
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        placeholder={t('writeMessage')}
      />
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={handleSendMessage}
        style={{ marginTop: 8 }}
      >
        {t('sendMessage')}
      </Button>
    </div>
  </Card>
        </div>

       <div className="class-schedule-container">
{classDetails.classes?.map((slot, index) => {
    const isLocked =
      currentUser?.role === 'teacher' &&
      currentUser.userid !== slot.teacher_id;


    return (
      <div
        key={index}
        className="class-schedule-card"
        style={{
          opacity: isLocked ? 0.5 : 1,
          pointerEvents: isLocked ? 'none' : 'auto',
          backgroundColor: isLocked ? '#f5f5f5' : 'white',
        }}
      >
        <Title level={4}>
          {t('class')} {index + 1} (
          <button
            onClick={() => handleViewLessonPlan(slot.classid)}
            style={{
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              color: '#1890ff',
              textDecoration: 'none',
            }}
          >
            ID: {slot.classid}
          </button>
          )
        </Title>
      <h3>{slot.subject_name}</h3>
      <h4><FontAwesomeIcon icon={faChalkboardTeacher} /> {slot.nickname}</h4> 
      <div className="video-meeting-link">
  {videoMeetingLinks[slot.classid] ? (
    <div className="video-meeting-active">
      <a 
        href={videoMeetingLinks[slot.classid]} 
        target="_blank" 
        rel="noopener noreferrer"
        className="video-join-link"
      >
        <FontAwesomeIcon icon={faVideo} />
        <span>{t('joinVideoMeeting')}</span>
      </a> 
      <button 
        className="delete-video-button" 
        onClick={() => handleDeleteVideoMeetingLink(slot.classid)}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </div>
  ) : (
    <div className="video-meeting-input">
      <input
        type="text"
        placeholder={t('addVideoMeetingLink')}
        value={newVideoMeetingLinks[slot.classid] || ''}
        onChange={(e) => handleNewVideoMeetingLink(slot.classid, e.target.value)}
      />
      <button 
        className="add-video-button"
        onClick={() => handleAddVideoMeetingLink(slot.classid)}
      >
        <FontAwesomeIcon icon={faVideo} />
      </button>
    </div>
  )}
</div>
      <p><FontAwesomeIcon icon={faCalendarAlt} /> {formatDate(slot.date)}</p>
      <p><FontAwesomeIcon icon={faClock} /> {formatTime(slot.schedule_time)} - {calculateClassEndTime(slot.schedule_time, slot.schedule_hour)}</p>
      <p><FontAwesomeIcon icon={faUserClock} /> {formatMinutesToHours(slot.schedule_hour)}</p>
      <p><FontAwesomeIcon icon={faDoorOpen} /> {slot.classroom_number}</p>

      <div className="pdf-section">
      <div className="pdf-upload-container">

  <h4>{t('Upload Homework')}</h4>
  

  {/* Upload Button Row */}
  <div className="pdf-upload-row">
            <label className="file-input-label">
              <input 
                type="file" 
                accept=".pdf" 
                onChange={(e) => handlePdfChange(e, slot.classid)}
                className="file-input" 
              />
              <FontAwesomeIcon icon={faCloudUpload} />
              <span>{selectedPdfs[slot.classid] ? selectedPdfs[slot.classid].name : t('Click to Choose PDF')}</span>
            </label>
            
            <button 
              onClick={() => handlePdfUpload(slot.classid)} 
              disabled={!selectedPdfs[slot.classid]} 
              className="upload-button"
            >
              <FontAwesomeIcon icon={faUpload} />
              {t('Upload')}
            </button>
          </div>
</div>


  <div className="uploaded-files-section">
    {uploadedPdfs[slot.classid]?.length > 0 && (
      <div className="homework-files">
        <h4>{t('Homework')}</h4>
        <div className="files-list">
          {uploadedPdfs[slot.classid].map((pdf, pdfIndex) => (
            <div key={pdfIndex} className="file-item">
              <FontAwesomeIcon icon={faFilePdf} className="file-icon" />
              <a
                href={`${API_URL}/upload/download/${pdf.filename}`}
                target="_blank"
                rel="noopener noreferrer"
                className="file-link"
              >
                {pdf.originalname}
              </a>
                          <button
              onClick={() => handleDeletePdf(pdf.id, slot.classid)}
  className="delete-video-button"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
</div>


<Space>
  <button 
  type="default"
  className="square-button"
  onClick={(e) => {
    e.stopPropagation(); 
    handleOpenSubmissions(slot.classid); 
  }}
>
  {t('Homework')} 
  ({studentUploadedPdfs[slot.classid]?.length || 0})
</button>

  <Button
    type="default"
    className="square-button"
    onClick={() => handleShowModal(slot)}
    disabled={submittedSchedules.includes(slot.classid)}
    icon={
      submittedSchedules.includes(slot.classid) ? <LockOutlined /> : <TeamOutlined />
    }
  >
    Attendance
  </Button>

  <Button
    type="default"
    className="square-button"
    onClick={() => handleOpenFeedback(slot)}
    icon={<EditOutlined />}
  >
    Feedback
  </Button>
</Space>

    </div>
    );
})}
</div>

        
      </div>

<Modal
      title={<Title level={4}>{classDetails?.class_code || t('scheduleDetails')}</Title>}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      width={800}
    >
      <Table 
        dataSource={sortedClasses} 
        columns={columns} 
        rowKey={(record, index) => index} 
        pagination={false}
        style={{
              overflowX: 'auto',
              width: '100%',
              maxWidth: '100%'
            }}
        size="middle"
      />
    </Modal>

    <Drawer
  title="Attendance"
  open={selectedClass !== null}
  onClose={() => setSelectedClass(null)}
  width={900}
  placement="right"
  footer={
    <div style={{ textAlign: 'right' }}>
      <Button onClick={() => setSelectedClass(null)} style={{ marginRight: 8 }}>
        Close
      </Button>
      <Button
        type="primary"
        onClick={downloadAttendanceCSV}
        icon={<FontAwesomeIcon icon={faFileAlt} />}
      >
        Download Report
      </Button>
    </div>
  }
>
  {selectedClass && (
    <>
      {/* Class Information Header */}
      <div style={{ marginBottom: 24, padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
          <h3 style={{ margin: 0, color: '#1890ff' }}>
            <FontAwesomeIcon icon={faBook} style={{ marginRight: 8 }} />
            {selectedClass.subject_name}
          </h3>
          <Tag color="blue">Class ID: {selectedClass.classid}</Tag>
        </div>
        <div style={{ display: 'flex', gap: 24, fontSize: 14, color: '#666' }}>
          <span>
            <FontAwesomeIcon icon={faCalendar} style={{ marginRight: 4 }} />
            {moment(selectedClass.date).format('DD-MMM-YYYY')}
          </span>
          <span>
            <FontAwesomeIcon icon={faClock} style={{ marginRight: 4 }} />
            {formatTime(selectedClass.schedule_time)} - {calculateClassEndTime(selectedClass.schedule_time, selectedClass.schedule_hour)}
          </span>
          <span>
            <FontAwesomeIcon icon={faUser} style={{ marginRight: 4 }} />
            {selectedClass.nickname}
          </span>
        </div>
      </div>



      {/* Students List */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {registeredStudents.map((student) => {
            const savedRecord = savedAttendances[student.student_id];
            const currentAttendance = attendance[student.student_id];
            
            return (
              <div 
                key={student.student_id} 
                style={{ 
                  border: '1px solid #e8e8e8', 
                  borderRadius: 8, 
                  padding: 16,
                  background: 'white',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >

                {savedRecord && !editMode[student.student_id] ? (
                  /* Saved Record View */
                  <div>
                    {/* Header row with name, status tag, and edit button */}
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'flex-start',
                      flexWrap: 'wrap',
                      gap: 8,
                      marginBottom: 12
                    }}>
                      <div>
                        <h5 style={{ margin: 0, color: '#1890ff' }}>
                          {student.student_name} ({student.nickname})
                        </h5>
                        <span style={{ fontSize: 12, color: '#666' }}>ID: {student.student_id}</span>
                      </div>
                      
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <Tag 
                          color={
                            savedRecord.status === 'Present' ? 'green' : 
                            savedRecord.status === 'Late_15' ? 'orange' :
                            savedRecord.status === 'Late_Over15' ? 'volcano' : 'red'
                          }
                        >
                          <FontAwesomeIcon icon={faLock} style={{ marginRight: 4 }} />
                          {savedRecord.status === 'Late_15' ? 'Late ≤ 15 M' :
                          savedRecord.status === 'Late_Over15' ? 'Late > 15 M' :
                          savedRecord.status}
                        </Tag>
                        <Button 
                          size="small"
                          onClick={() => handleEdit(student.student_id)}
                          icon={<FontAwesomeIcon icon={faEdit} />}
                        >
                          Edit
                        </Button>
                      </div>
                    </div>

                    {/* Details row */}
                    <div style={{ 
                      display: 'flex', 
                      gap: 24, 
                      flexWrap: 'wrap',
                      fontSize: 13,
                      color: '#666',
                      paddingTop: 8,
                      borderTop: '1px solid #f0f0f0'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ color: '#999' }}>Homework:</span>
                        <Tag
                          size="small"
                          color={
                            savedRecord.homework === 'YES' ? 'green' :
                            savedRecord.homework === 'NO' ? 'red' : 'default'
                          }
                        >
                          <FontAwesomeIcon 
                            icon={
                              savedRecord.homework === 'YES' ? faCheck :
                              savedRecord.homework === 'NO' ? faTimes : faMinus
                            } 
                            style={{ marginRight: 4 }}
                          />
                          {savedRecord.homework}
                        </Tag>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <FontAwesomeIcon icon={faClock} style={{ color: '#999' }} />
                        <span>{moment(savedRecord.timestamp).format('DD-MMM-YYYY HH:mm')}</span>
                      </div>

                      {savedRecord.edited_at && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#ff7a00' }}>
                          <FontAwesomeIcon icon={faEdit} />
                          <span>Edited: {moment(savedRecord.edited_at).format('DD-MMM-YYYY HH:mm')}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  /* Edit Mode */
                  <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(2, 1fr)', 
                      gap: 12, 
                      alignItems: 'flex-start' 
                    }}>
                    <div>
                      <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>Status</label>
                      <Select
                        value={currentAttendance?.status || ''}
                        onChange={(value) => handleAttendanceChange(student.student_id, 'status', value)}
                        placeholder="Select Status"
                        style={{ width: '100%', marginTop: 4 }}
                      >
                        <Select.Option value="Present">{t('present')}</Select.Option>
                        <Select.Option value="Absent">{t('absent')}</Select.Option>
                        <Select.Option value="Late_15">{t('Late ≤ 15 M')}</Select.Option>
                        <Select.Option value="Late_Over15">{t('Late > 15 M')}</Select.Option>

                      </Select>
                    </div>
                    
                    <div>
                      <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>Homework</label>
                      <Select
                        value={homework[student.student_id] || ''}
                        onChange={(value) => handleHomeworkChange(student.student_id, value)}
                        placeholder="Select Status"
                        style={{ width: '100%', marginTop: 4 }}
                      >
                        <Select.Option value="YES">YES</Select.Option>
                        <Select.Option value="NO">NO</Select.Option>
                        <Select.Option value="N/A">N/A</Select.Option>
                      </Select>
                    </div>
                    

                    
                    <div style={{ gridColumn: '1 / -1' }}>
                      <Button
                        type="primary"
                        onClick={() => editMode[student.student_id] ? 
                          handleUpdate(student.student_id) : 
                          handleSaveAttendance(student.student_id)
                        }
                        disabled={savingInProgress || !currentAttendance?.status}
                        icon={<FontAwesomeIcon icon={faSave} />}
                        block
                      >
                        {editMode[student.student_id] ? 'Update' : 'Save'}
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Quick Actions */}
      <div style={{ 
        marginTop: 24, 
        padding: 16, 
        background: '#f0f9ff', 
        borderRadius: 8,
        border: '1px solid #bae7ff'
      }}>
        <h5 style={{ margin: 0, marginBottom: 8, color: '#1890ff' }}>Quick Actions</h5>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Button 
            size="small" 
            icon={<FontAwesomeIcon icon={faFileAlt} />}
            onClick={downloadAttendanceCSV}
          >
            Export Report
          </Button>
          <Button 
            size="small" 
            onClick={() => {
              // Mark all as present
              registeredStudents.forEach(student => {
                if (!savedAttendances[student.student_id]) {
                  handleAttendanceChange(student.student_id, 'status', 'Present');
                }
              });
            }}
          >
            Mark All Present
          </Button>
        </div>
      </div>
    </>
  )}
</Drawer>
<Drawer
  title="Homework Submissions"
  open={isSubmittedHomeworkOpen}
  onClose={() => setIsSubmittedHomeworkOpen(false)}
  width={700}
  placement="right"
  style={{ zIndex: 1000 }}
  maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
  footer={
    <div style={{ textAlign: 'right' }}>
      <Button onClick={() => setIsSubmittedHomeworkOpen(false)} style={{ marginRight: 8 }}>
        Close
      </Button>
      {studentUploadedPdfs[selectedClassId]?.length > 0 && (
        <Button
          type="primary"
          onClick={downloadCSV}
          icon={<FontAwesomeIcon icon={faFileAlt} />}
        >
          Download Report
        </Button>
      )}
    </div>
  }
>
  {/* Class Information Header */}
  {selectedClassId && classDetails?.classes?.filter(cls => cls.classid === selectedClassId).map(selectedClass => (
    <div key={selectedClass.classid} style={{ marginBottom: 24, padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
        <h3 style={{ margin: 0, color: '#1890ff' }}>
          <FontAwesomeIcon icon={faBook} style={{ marginRight: 8 }} />
          {selectedClass.subject_name}
        </h3>
        <Tag color="blue">Class ID: {selectedClass.classid}</Tag>
      </div>
      <div style={{ display: 'flex', gap: 24, fontSize: 14, color: '#666' }}>
        <span>
          <FontAwesomeIcon icon={faCalendar} style={{ marginRight: 4 }} />
          {moment(selectedClass.date).format('DD-MMM-YYYY')}
        </span>
        <span>
          <FontAwesomeIcon icon={faClock} style={{ marginRight: 4 }} />
          {formatTime(selectedClass.schedule_time)} - {calculateClassEndTime(selectedClass.schedule_time, selectedClass.schedule_hour)}
        </span>
        <span>
          <FontAwesomeIcon icon={faUser} style={{ marginRight: 4 }} />
          {selectedClass.nickname}
        </span>
      </div>
    </div>
  ))}

  {/* Submissions Summary */}
  <div style={{ marginBottom: 24 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
      <h4 style={{ margin: 0 }}>Submission Summary</h4>
      <Tag color={studentUploadedPdfs[selectedClassId]?.length > 0 ? 'green' : 'orange'}>
        {studentUploadedPdfs[selectedClassId]?.length || 0} Submissions
      </Tag>
    </div>
  </div>

  {/* Submissions List */}
  {studentUploadedPdfs[selectedClassId]?.length > 0 ? (
    <div style={{ marginBottom: 24 }}>
      <h4 style={{ marginBottom: 16, color: '#52c41a' }}>
        <FontAwesomeIcon icon={faCheck} style={{ marginRight: 8 }} />
        Submitted Homework
      </h4>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {studentUploadedPdfs[selectedClassId].map((pdf, index) => (
          <div 
            key={index} 
            style={{ 
              border: '1px solid #e8e8e8', 
              borderRadius: 8, 
              padding: 16,
              background: 'white',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                  <h5 style={{ margin: 0, color: '#1890ff' }}>{pdf.nickname}</h5>
                  <Tag color="green" size="small">
                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: 4 }} />
                    Submitted
                  </Tag>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: '#ff4d4f' }} />
                  <span style={{ fontWeight: 500 }}>{pdf.originalname}</span>
                </div>
                
                <div style={{ fontSize: 12, color: '#666' }}>
                  <FontAwesomeIcon icon={faClock} style={{ marginRight: 4 }} />
                  Uploaded: {formatUploadDate(pdf.upload_date)}
                </div>
              </div>
              
              <div style={{ marginLeft: 16 }}>
                <Button
                  type="primary"
                  size="small"
                  icon={<FontAwesomeIcon icon={faCloudUpload} />}
                  href={`${API_URL}/upload/download/${pdf.filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div style={{ 
      textAlign: 'center', 
      padding: '60px 20px',
      background: '#fafafa',
      borderRadius: 8,
      border: '1px dashed #d9d9d9'
    }}>
      <div style={{ marginBottom: 16 }}>
        <FontAwesomeIcon 
          icon={faFileAlt} 
          style={{ 
            fontSize: 48, 
            color: '#d9d9d9' 
          }} 
        />
      </div>
      <h4 style={{ color: '#8c8c8c', margin: 0, marginBottom: 8 }}>No Homework Submitted</h4>
      <p style={{ color: '#bfbfbf', margin: 0, fontSize: 14 }}>
        No students have submitted homework for this class yet.
      </p>
    </div>
  )}

  {/* Additional Actions */}
  {studentUploadedPdfs[selectedClassId]?.length > 0 && (
    <div style={{ 
      marginTop: 24, 
      padding: 16, 
      background: '#f0f9ff', 
      borderRadius: 8,
      border: '1px solid #bae7ff'
    }}>
      <h5 style={{ margin: 0, marginBottom: 8, color: '#1890ff' }}>Quick Actions</h5>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <Button 
          size="small" 
          icon={<FontAwesomeIcon icon={faFileAlt} />}
          onClick={downloadCSV}
        >
          Export Report
        </Button>
        <Button 
          size="small" 
          onClick={() => {
          }}
        >
          View All Files
        </Button>
      </div>
    </div>
  )}
</Drawer>
<Drawer
        title="Submit Feedback"
        open={feedbackVisible}
        onClose={handleCloseFeedback}
        width={600}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={handleCloseFeedback} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSubmitFeedback}
              disabled={isFeedbackApproved} 
            >
              Submit
            </Button>
          </div>
        }
      >
        {studentId && (
            isFeedbackApproved ? (
              <Tag color="green" style={{ marginBottom: 16 }}>Approved</Tag>
            ) : (
              <Tag color="orange" style={{ marginBottom: 16 }}>Pending Approval</Tag>
            )
          )}

        <Form layout="vertical" disabled={isFeedbackApproved}>
          <Form.Item label="Student" required>
           <Select
                  value={studentId}
                  onChange={async (value) => {
                    setStudentId(value);

                    try {
                      const token = localStorage.getItem('token');
                      const res = await axios.get(
                        `${API_URL}/student-feedback/by-classid-student/${selectedClassFeedback.classid}/${value}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                      );

                      if (res.data) {
                        setFeedbackData({
                          warmup: res.data.warmup || '',
                          task_1: res.data.task_1 || '',
                          task_2: res.data.task_2 || '',
                          task_3: res.data.task_3 || '',
                          homework: res.data.homework || '',
                          reflection: res.data.reflection || '',
                          comment: res.data.comment || ''
                        });
                        setIsFeedbackApproved(res.data.approve !== 'pending');
                      } else {
                        // No feedback exists
                        setFeedbackData({
                          warmup: '',
                          task_1: '',
                          task_2: '',
                          task_3: '',
                          homework: '',
                          reflection: '',
                          comment: ''
                        });
                        setIsFeedbackApproved(false);
                      }
                    } catch (err) {
                      console.error('❌ Failed to fetch feedback:', err);
                      message.warning('Could not load feedback for this student');
                    }
                  }}
                  placeholder="Select a student"
                >
                  {studentsInClass.map((student) => (
                    <Select.Option key={student.student_id} value={student.student_id}>
                      ({student.nickname}) {student.student_name} {student.student_id}
                    </Select.Option>
                  ))}
                </Select>
          </Form.Item>

          <Form.Item label="Warmup">
            <Input.TextArea
              value={feedbackData.warmup}
              onChange={(e) => setFeedbackData({ ...feedbackData, warmup: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Task 1">
            <Input.TextArea
              value={feedbackData.task_1}
              onChange={(e) => setFeedbackData({ ...feedbackData, task_1: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Task 2">
            <Input.TextArea
              value={feedbackData.task_2}
              onChange={(e) => setFeedbackData({ ...feedbackData, task_2: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Task 3">
            <Input.TextArea
              value={feedbackData.task_3}
              onChange={(e) => setFeedbackData({ ...feedbackData, task_3: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Homework">
            <Input.TextArea
              value={feedbackData.homework}
              onChange={(e) => setFeedbackData({ ...feedbackData, homework: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Reflection">
            <Input.TextArea
              value={feedbackData.reflection}
              onChange={(e) => setFeedbackData({ ...feedbackData, reflection: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Comment">
            <Input.TextArea
              value={feedbackData.comment}
              onChange={(e) => setFeedbackData({ ...feedbackData, comment: e.target.value })}
            />
          </Form.Item>
        </Form>
      </Drawer>


    {/* Lesson Plan Modal */}
    <LessonPlanModal
        open={lessonPlanVisible}
        onCancel={() => setLessonPlanVisible(false)}
        currentLessonPlan={currentLessonPlan}
        lessonPlanLoading={lessonPlanLoading}
        setLessonPlanVisible={setLessonPlanVisible}
      />
    </div>
  );
};

export default withRoleAccess(ClassDetails, ['admin', 'superadmin', 'teacher']);
